import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import { ConfigProvider } from '../config/config';

import { AppDetectorProvider } from '../detector/detector';
import { RequestProvider } from '../request/request';
import { Config } from '@ionic/angular';
import { Subject } from 'rxjs';
import { StorageProvider } from '../storage-service/storage-service';

/*
  Generated class for the SettingsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

export interface LanguageModel {
  short: string
  lang: string
}

export interface LocalLanguageModel {
  success: boolean;
  language: string;
  country: string;
}
export interface DateFormatModel {
  key: string;
  pipeFormat: string;
  name: string;
}

@Injectable()
export class SettingsProvider {
  activeDateFormat: string = "dd.MM.yyyy";
  dateFormatChangeSubject$ = new Subject();

  constructor(
    public request: RequestProvider,
    private storage: Storage,
    private config: ConfigProvider,
    public translateService: TranslateService,
    private configS: Config,
    private storageService:StorageProvider,
    private appDetector: AppDetectorProvider) {
    this.translateService.setDefaultLang("de");
    this.getActiveLanguage().then(res => {
      console.log('lang = ' + res);
      this.translateService.setDefaultLang(res);
    //   this.translateService.get('GLOBAL_BACK').subscribe(backLabel => {
    //     console.log(backLabel);
    //     // this.configS.set('ios', 'backButtonText', backLabel);
    //   });
    });
  }


  getLanguages(): Promise<LanguageModel[]> {
    return new Promise((resolve, reject) => {
      this.request.get("assets/data/settings/language.json")
        .toPromise()
        .then((values: LanguageModel[]) => {
          resolve(values)
        }).catch((error) => {
          resolve([]);
        });
    });
  }

  getDateFormats(): Promise<DateFormatModel[]> {
    return new Promise((resolve, reject) => {
      this.request.get("assets/data/settings/dateformat.json")
        .toPromise()
        .then((values: DateFormatModel[]) => {
          resolve(values)
        }).catch((error) => {
          resolve([]);
        });
    });
  }


  async setDateFormat(dateFormat: DateFormatModel): Promise<void> {
    this.dateFormatChangeSubject$.next(dateFormat);
    this.activeDateFormat = dateFormat.key;
    await this.storageService.create();
    await this.storageService._storage.set("selectedDateFormat", JSON.stringify(dateFormat));
  }

  enableAutoLocalization(): Promise<void> {
    return this.getUserCountry().then(async(location: LocalLanguageModel) => {
      console.log('location', location)
      let storedLang = await this.storageService._storage.get("selectedLanguage");
      console.log('storedLang', storedLang)
      if(storedLang!==null && storedLang!==location.country.toLowerCase()) return
      if (this.isGermanSpeaking(location.country)) {
        this.translateService.setDefaultLang("de");
        await this.setLanguage("de");
      }
      else {
        this.translateService.setDefaultLang("en");
        await this.setLanguage("en");
      }
    }).catch(err => {
      this.getActiveLanguage().then(lang => this.translateService.setDefaultLang(lang));
      console.warn("error while enabling auto localization: " + err);
    });
  }

  getUserCountry(): Promise<LocalLanguageModel> {
    return new Promise<any>((resolve, reject) => {
//@ts-ignore
      let abortController = new AbortController();
      setTimeout(() => abortController.abort(), 5000);

      fetch("https://ipapi.co/json", {
//@ts-ignore
        signal: abortController.signal
      }).then((response) => response.json())
        .then((location) => resolve({ success: true, country: location.country, language: "" }))
        .catch((err) => {
          console.log('Error by fetching the current country... ' + err);
          this.getActiveLanguage().then(language => resolve({
            success: false, country: "", language: language
          }));
        }).catch((err) =>{
          if (err.status === 400 || err.status === 401) {
            alert(err.error.message);
            return null;
          }
          reject()
        });
    });
  }

  async getActiveLanguage(): Promise<string> {
    await this.storageService.create();
    const lang = await this.storageService._storage.get("selectedLanguage");
    return lang || this.config.defaultLanguage;
  }

  getActiveDateFormat(): Promise<DateFormatModel> {
    return new Promise(async(resolve, reject) => {
      await this.storageService.create();
      this.storageService._storage.get("selectedDateFormat").then((dateFormat) => {
        if (!dateFormat) {
          resolve({
            "key": "dd.MM.yyyy",
            "pipeFormat": "dd.MM.yyyy",
            "name": "dd.MM.yyyy (16.10.2023)"
          });
        } else {
          resolve(JSON.parse(dateFormat));
        }
      })
    });
  }

  isGermanSpeaking(country) {
    if (this.appDetector.isGesunderApp()) return true;

    if (country === "AT" || country === "DE" || country === "CH") {
      return true;
    } else {
      return false;
    }
  }

  async setLanguage(lang: string): Promise<string> {
    await this.storageService.create();
    await this.storageService._storage.set("selectedLanguage", lang);
    this.translateService.setDefaultLang(lang);
    return lang;
  }
}